import { HomePageStarredEntities, LayoutConfiguration } from '@backstage/plugin-home';
import {
  HomepageAddYourServiceCard,
  HomepagePavedPathsCard,
  HomepageInternalToolsCard,
  HomepageGetHelpCard,
} from './plugins';
import { JiraUserIssuesViewCard } from '@axis-backstage/plugin-jira-dashboard';
import { HomePageSearchBar } from '@backstage/plugin-search';

export const defaultConfig: LayoutConfiguration[] = [
  {
    component: <HomePageSearchBar />,
    x: 0,
    y: 2,
    width: 12,
    height: 2,
  },
  {
    component: <HomepagePavedPathsCard />,
    x: 0,
    y: 3,
    width: 6,
    height: 8,
  },
  {
    component: <JiraUserIssuesViewCard />,
    x: 6,
    y: 3,
    width: 6,
    height: 8,
  },
  {
    component: <HomePageStarredEntities />,
    x: 0,
    y: 12,
    width: 6,
    height: 4,
  },
  {
    component: <HomepageAddYourServiceCard />,
    x: 6,
    y: 12,
    width: 6,
    height: 4,
  },
  {
    component: <HomepageGetHelpCard />,
    x: 0,
    y: 13,
    width: 6,
    height: 6,
  },
  {
    component: <HomepageInternalToolsCard tools={[]} />,
    x: 0,
    y: 19,
    width: 17,
    height: 4,
  },
];
